import React, { useLayoutEffect, useRef, useState } from 'react';

// Shrinks its contents just enough to always sit on a single line, no matter how
// large the value. When there is room it renders at full size; for very large
// amounts it scales the text down (never up) so it never overflows or wraps.
export function FitText({ children, className = '', align = 'left', min = 0.5, style, ...rest }) {
  const wrapRef = useRef(null);
  const innerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const fit = () => {
      const wrap = wrapRef.current;
      const inner = innerRef.current;
      if (!wrap || !inner) return;
      const avail = wrap.clientWidth;
      const need = inner.scrollWidth;
      if (need > 0 && avail > 0 && need > avail) {
        setScale(Math.max(min, avail / need));
      } else {
        setScale(1);
      }
    };
    fit();
    let ro;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(fit);
      if (wrapRef.current) ro.observe(wrapRef.current);
    }
    window.addEventListener('resize', fit);
    return () => { if (ro) ro.disconnect(); window.removeEventListener('resize', fit); };
  }, [children, min]);

  return (
    <div
      ref={wrapRef}
      className={className}
      {...rest}
      style={{ overflow: 'hidden', display: 'flex', justifyContent: align === 'center' ? 'center' : align === 'right' ? 'flex-end' : 'flex-start', ...style }}
    >
      <span
        ref={innerRef}
        style={{ whiteSpace: 'nowrap', transformOrigin: align === 'center' ? 'center' : align === 'right' ? 'right' : 'left', transform: `scale(${scale})` }}
      >
        {children}
      </span>
    </div>
  );
}
